import type { FormComponents } from '../../../../types/form/Form';
import type { Action } from '../../../../types/context-action/action';
import type { FormValidationErrors } from '../../FormValidator';

export const GLOBAL_ACTIONS = {
  CLOSE_NOTIFICATION: 'CLOSE_NOTIFICATION',
  UPDATE_COMPONENTS: 'UPDATE_COMPONENTS',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
} as const;

export type CloseNotificationAction = Action<
  typeof GLOBAL_ACTIONS.CLOSE_NOTIFICATION
>;

export type UpdateComponentsAction = Action<
  typeof GLOBAL_ACTIONS.UPDATE_COMPONENTS,
  {
    payload: FormComponents;
  }
>;

export type ValidationFailedAction = Action<
  typeof GLOBAL_ACTIONS.VALIDATION_FAILED,
  {
    errors: FormValidationErrors;
  }
>;

export type GlobalAction =
  | CloseNotificationAction
  | UpdateComponentsAction
  | ValidationFailedAction;
